import {JWTHelper} from "@/helpers/JWTHelper";

const RECONNECT_DELAY = 5000;

const listeners = new Map();
let socket = null;
let reconnectTimer = null;
let hasConnected = false;

function notifyAll() {
    listeners.forEach((handlers) => handlers.forEach((handler) => handler(null)));
}

function connect() {
    if (socket || !listeners.size || !process.env.VUE_APP_WS_BASE_URL) return;
    socket = new WebSocket(process.env.VUE_APP_WS_BASE_URL);
    socket.onopen = () => {
        const authToken = JWTHelper.getJwt();
        if (authToken) socket.send(JSON.stringify({pushType: "PUSH_AUTH_TOKEN", authToken}));
        if (hasConnected) notifyAll();
        hasConnected = true;
    };
    socket.onmessage = (event) => {
        let message;
        try {
            message = JSON.parse(event.data);
        } catch (e) {
            return;
        }
        const handlers = listeners.get(message?.pushType);
        if (handlers) handlers.forEach((handler) => handler(message.data));
    };
    socket.onclose = () => {
        socket = null;
        if (!listeners.size) return;
        reconnectTimer = setTimeout(() => {
            reconnectTimer = null;
            connect();
        }, RECONNECT_DELAY);
    };
}

function disconnect() {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
    hasConnected = false;
    if (!socket) return;
    const closing = socket;
    socket = null;
    closing.onclose = null;
    closing.close();
}

export const pushService = {
    subscribe(pushType, handler) {
        const handlers = listeners.get(pushType) || new Set();
        handlers.add(handler);
        listeners.set(pushType, handlers);
        connect();
        return () => {
            handlers.delete(handler);
            if (!handlers.size) listeners.delete(pushType);
            if (!listeners.size) disconnect();
        };
    }
};
